import { render, staticRenderFns } from "./about-priority.vue?vue&type=template&id=4167c748"
import script from "./about-priority.vue?vue&type=script&lang=js"
export * from "./about-priority.vue?vue&type=script&lang=js"
import style0 from "./about-priority.vue?vue&type=style&index=0&id=4167c748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports